const Roles = {
  Administrator: 'Administrator',
  Supervisor: 'Supervisor',
  User: 'User',
};

export default Roles;
